<template>
    <div>  
      <egg-description
        title="tpa.tpaOss"
        titleColor="#603813"
        :starIconObj="{ componentName: 'shared', imgName: 'starIconPurple', imgFormat: 'svg' }"
        :eggImgObj="{ componentName: 'tpa', imgName: 'oss', imgFormat: 'png', position: 'right' }"
        :isShowStarBackgroundRight="false"
        :starBackgroundLeftObj="{ componentName: 'shared', imgName: 'starGroupIconLightBlueLeft', imgFormat: 'svg', bottom: '60%' }"
        textMode="paragraph"
        :description="tpaStore.adultDescList"
        class="pb-36"
      />
    </div>
  </template>
  
  <script setup lang="ts">
  import { useTpaStore } from "@/stores/tpa";
  import { computed, onMounted, ref, toRefs } from "vue";
  import { useRouter } from "vue-router";
  
  const tpaStore = useTpaStore();
  const router = useRouter();
  
  onMounted(async () => {});
  
  //not on home page, stop intro timer
  router.beforeEach(async (to, from) => {});
  
  const goTo = (refName) => {};
  
  const routeTo = (position) => {
    router.push({ name: position, params: { uid: "lczmx" } });
  };
  </script>